import { axiosGetPost } from '@router/axiosGetPost'

export function downloadOperationsFile(id, modeType) {
  let url = null
  if (modeType.toUpperCase() === 'FCL') {
    url = '/contracts/downloadF/'
  } else {
    url = '/contractsLcl/downloadF/'
  }

  axiosGetPost('get', url + id,{} ,"Download File " + modeType + " Operations" ).then((response) => {
    console.log(response)
    let data = response.data
    if (data.success === true) {
      var link = document.createElement('a')
      link.setAttribute('target', '_blank')
      link.href = data.url
      link.click()
      URL.revokeObjectURL(link.href)
    } else {
      this.$toastr.e(
        'Error Download. Status code: ' +
        data.status +
        ' Error: ' +
        data.error
      )
    }
    return data
  })
}
